import React from 'react'
import NavBar from '../components/Home/NavBar'
import ConsentimientoUsuarioNuevo from '../components/Forms/ConsentimientoBilateral/ConsentimientoUsuarioNuevo'

const RenovacionConsentimiento = () => {
  return (
    <div>
      <NavBar />
      <div className='flex items-center justify-center p-12'>
      <ConsentimientoUsuarioNuevo/>
      </div>
    </div>
  )
}

export default RenovacionConsentimiento